// My component for rendering text consistently throughout.
export const PrimaryText = ( {children} ) => (
  <div className="container pt-2 text-center text-primary">
	{children}
  </div>
)